import { DateInputLocalized } from '@components'

import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceEditorForm } from '../../../../../../contexts/invoiceEditorFormContext'
import { useIsInvoiceEditorElementRestricted } from '../../../../../../hooks/useIsInvoiceEditorElementRestricted'

export const DueDate = (): ReactElement => {
  const { t } = useTranslation()
  const isDisabled = useIsInvoiceEditorElementRestricted('dueDate', 'disabled')
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm

  const handleDatePickerOpen = useCallback(() => {
    trackInvoiceEditor('Form - Due date picker opened')
  }, [trackInvoiceEditor])

  return (
    <FormItem
      name="dueDate"
      label={t('external_invoices.editor.form.field.due_date.label')}
      render={({ field: { onChange, ...props } }) => (
        <DateInputLocalized
          {...props}
          disabled={isDisabled}
          onChange={(date) => {
            onChange(date)
            trackInvoiceEditor('Form - Due date selected', {
              date,
            })
          }}
          onOpen={handleDatePickerOpen}
          size="sm"
        />
      )}
    />
  )
}
